import { render, staticRenderFns } from "./utpItem.vue?vue&type=template&id=f626e9e6&scoped=true"
import script from "./utpItem.vue?vue&type=script&lang=js"
export * from "./utpItem.vue?vue&type=script&lang=js"
import style0 from "./utpItem.vue?vue&type=style&index=0&id=f626e9e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f626e9e6",
  null
  
)

export default component.exports